import { RemoteLessonEmployeeRecipientDTO } from 'types';
import { ExtendedDataNode } from 'components/atoms';
import { messagesTexts } from 'consts/text';
import { parseRemoteLessonReceiverDTOIntoExtendedDataNode } from 'utils/parsers/remoteLessons/parseRemoteLessonReceiverDTOIntoExtendedDataNode';

const DATA_NODE_KEY = 'employees';

export const parseRemoteLessonReceiverDTOsIntoExtendedDataNodes: (
    remoteLessonReceiverDTOs: RemoteLessonEmployeeRecipientDTO[],
) => ExtendedDataNode[] = (remoteLessonReceiverDTOs) => {
    const childrenDataNodes: ExtendedDataNode[] = remoteLessonReceiverDTOs.map(
        parseRemoteLessonReceiverDTOIntoExtendedDataNode,
    );
    return [
        {
            title: messagesTexts.recipientsPicker.employees,
            key: DATA_NODE_KEY,
            children: childrenDataNodes,
        },
    ];
};
